import { useState, useCallback } from 'react';
import _ from 'lodash';

import { handlePromise } from 'utils';

export default ( {
  initialState = { data: [], elementsTotal: 0 }, promise, conditional, deps = [], toggleErrorAlert,
  callback,
} ) => {
  const [data, setData] = useState( initialState );
  const [dataLoading, setDataLoading] = useState();

  const fetchData = useCallback( ( apiParams ) => {
    const getData = async ( params ) => {
      setDataLoading( true );
      const [errors, response, responseData] = await handlePromise( promise( params ) );
      setDataLoading( false );

      if ( !response.ok ) {
        return toggleErrorAlert
          ? toggleErrorAlert( errors ) : [initialState, false];
      }
      setData( _.isEmpty( responseData ) ? initialState : responseData );
      if ( callback ) callback( apiParams );
    };
    if ( conditional === undefined ) getData( apiParams );
    else if ( conditional ) getData( apiParams );
  }, [...deps] ); //eslint-disable-line

  return [fetchData, data, dataLoading];
};
